


























































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'

export interface InputOfReserveContactSituationCollectionInfoItem {
  collectionNo: string
  holdingBranchCode: SystemCode
  callNumber: string
  shelfType: SystemCode
  collectionType: SystemCode
  status: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  updatedTime: string
  updatedBranchCode: SystemCode
}

export const defaultInputOfReserveContactSituationCollectionInfoItem = (): InputOfReserveContactSituationCollectionInfoItem => ({
  collectionNo: '',
  holdingBranchCode: defaultSystemCode(),
  callNumber: '',
  shelfType: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  status: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  appendixCode: defaultSystemCode(),
  updatedTime: '',
  updatedBranchCode: defaultSystemCode()
})

@Component({
  components: {}
})
export default class InputOfReserveContactSituationCollectionInfo extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: InputOfReserveContactSituationCollectionInfoItem
}
